<template>
  <customdialog
    v-model="dialog"
    :maxWidth="options.width"
    :title="$t('Filter-selection')"
    :cardtextstyle="'height: 600px;'"
  >
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm6 md12 pa-1>
          <v-card flat class="white--text">
            <v-card flat color="grey lighten-5">
              <v-card-actions>
                <v-layout row wrap>
                  <v-flex md12 xs12 sm12>
                    <pnrbul v-model="Rapor.PPNR_No" hide-details> </pnrbul>
                  </v-flex>
                  <v-flex md12 xs12 sm12>
                    <cariaracomp
                      v-bind:etiket="$t('Currentcode_label')"
                      v-bind:value="Rapor.PCariKod"
                      v-model="Rapor.PCariKod"
                      :Coper="true"
                    ></cariaracomp>
                  </v-flex>
                  <v-flex md12 xs12 sm12>
                    <cariaracomp
                      v-bind:etiket="$t('Current-Main-Account')"
                      v-bind:value="Rapor.PCariAnaHesap"
                      v-model="Rapor.PCariAnaHesap"
                      :Coper="true"
                    ></cariaracomp>
                  </v-flex>
                  <v-flex md6 xs12 sm6>
                    <v-select
                      clearable
                      :items="itemssaticitip"
                      item-text="Aciklama"
                      item-value="Kod"
                      v-model="Rapor.PSaticiTip"
                      :label="$t('Seller-Type')"
                      hide-details=""
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <genelarama
                      :autofocuss="true"
                      apiname="SaticiAra"
                      :tip="Rapor.PSaticiTip"
                      :label="$t('Seller-Code')"
                      v-model="Rapor.PSaticiKod"
                    ></genelarama>
                  </v-flex>
                  <v-flex v-if="!simpleMode"  pl-1 xs12 sm12 md12>
                    <genelarama
                      apiname="MasrafMerkeziAra"
                      :label="$t('Expense-Center-v2')"
                      v-model="Rapor.PMasrafMerkezi"
                    ></genelarama>
                  </v-flex>
                  <v-flex v-if="!simpleMode"  pl-1 xs12 sm12 md12>
                    <v-select hide-details :label="$t('Profile-Template')" v-model="Rapor.PProfilSablonId" :items="sablonTipList"  item-text="SAblonAdi" item-value="SablonId" >
                    </v-select>
                  </v-flex>
                
                  <v-flex v-if="!simpleMode"  xs12 sm12 md12>
                    <referansmerkezicomp
                      v-model="Rapor.PReferans"
                      :etiket="$t('Reference-Centre')"
                      :coper="true"
                    >
                    </referansmerkezicomp>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <genelarama
                      apiname="SaticiAra"
                      :tip="12"
                      :label="$t('Tour-Operator')"
                      v-model="Rapor.PTurOp"
                    >
                    </genelarama>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <genelarama
                      apiname="SaticiAra"
                      :tip="4"
                      :label="$t('Agency')"
                      v-model="Rapor.PAcente"
                    >
                    </genelarama>
                  </v-flex>
                  <v-flex md12 xs12 sm12>
                    <v-select
                      :items="itemsicdis"
                      item-text="text"
                      item-value="value"
                      v-model="Rapor.PSaticiIc_Dis"
                      label="İç Dış"
                      hide-details=""
                    >
                    </v-select>
                  </v-flex>

                  <v-flex md12 xs12 sm12>
                    <v-select
                      :items="itemsopsiyon"
                      item-text="text"
                      item-value="value"
                      v-model="Rapor.POpsiyon"
                      :label="$t('Optional-Sales')"
                      hide-details=""
                    >
                    </v-select>
                  </v-flex>

                  <v-flex v-if="!simpleMode"  md12 xs12 sm12>
                    <anatip v-model="Rapor.PAnaTip"></anatip>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-select
                      hide-details
                      :items="doviztipi"
                      v-model="Rapor.PPNR_ParaBirimi"
                      item-text="Title"
                      item-value="DovizKod"
                      :label="$t('Currency-Unit')"
                    ></v-select>
                  </v-flex>
                  <v-flex v-if="!simpleMode"  xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      v-model="Rapor.PCariHesapGrubu"
                      :label="$t('Account-Group')"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex v-if="!simpleMode"  xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      v-model="Rapor.PSaticiGrup"
                      :label="$t('Seller-Group')"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      v-model="Rapor.PSatisFaturaNo"
                      :label="$t('Invoice-No')"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select
                      hide-details
                      :items="itemskomisyon"
                      v-model="Rapor.PKomisyonFaturali"
                      item-text="text"
                      item-value="value"
                      :label="$t('Commission-Invoice')"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      hide-details
                      v-model="Rapor.PIptalRaporu"
                      :label="$t('Cancellation-Report')"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      hide-details
                      v-model="Rapor.PSaticiOdemesiHesapla"
                      :label="$t('Calculate-Seller-Payments')"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex>
                    <genelarama
                      apiname="KullaniciAra"
                      :label="$t('Booker') + ':'"
                      v-model="Rapor.PPNRBir"
                    ></genelarama>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="tumsirketler"
                      :label="$t('All-Companies')"
                      hide-details=""
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      :label="this.$t('To-Our-Hotel-by-Customer')"
                      v-model="Rapor.PSatisTip1"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      :label="this.$t('By-our-agency-excluding extras')"
                      v-model="Rapor.PSatisTip2"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      :label="this.$t('Full-Credit-by-our-agency')"
                      v-model="Rapor.PSatisTip3"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      :label="this.$t('By-Tour-Operator')"
                      v-model="Rapor.PSatisTip4"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>

    <template slot="btn">
      <v-btn color="primary" flat @click.native="yes()">{{
        $t("Apply-Filters")
      }}</v-btn>
      <v-btn color="primary" flat @click.native="cancel()">
        {{ $t("Clean") }}
      </v-btn>
    </template>
  </customdialog>
</template>

<script>
import auth from "../../../../api/auth";
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import tarihcomp from "../../customcomp/tarihim";
import anatip from "@/components/app/coper/comp/anatip.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import helpers from "@/components/app/customcomp/helpers.js"
import rez from "../rezervasyon";
import tool from "../tools";
import { i18n } from '@/plugins/i18n.js'
export default {
  data() {
    return {
      simpleMode: false,
      sablonTipList: [],
      tumsirketler: false,
      dialog: false,

      resolve: null,
      reject: null,

      returnData: {
        Status: false,
        Rapor: this.EmptyPrametre2(),
      },

      Rapor: this.EmptyPrametre2(),

      itemskomisyon: [
        {
          text: this.$t("None"),
          value: false,
        },
        {
          text: this.$t("Available"),
          value: true,
        },
        {
          text: this.$t("All-v2"),
          value: null,
        },
      ],
      itemsopsiyon: rez.Opsiyon,
      doviztipi: [],
      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,

      options: {
        color: "primary",
        width: 600,
        message: null,
      },
    };
  },
  EmptyPrametre() {
    return EmptyPrametre2();
  },

  RaporTarihAyarla(Rapor, tarihTip, KayitTarihiBasla, KayitTarihiBitis) {
    Rapor.PKayitTarihBas = null;
    Rapor.PKayitTarihBit = null;
    Rapor.PDonem1Bas = null;
    Rapor.PDonem1Bit = null;
    Rapor.PDonem2Bas = null;
    Rapor.PDonem2Bit = null;
    Rapor.PFatTarihBas = null;
    Rapor.PFatTarihBit = null;
    Rapor.PKomFatTarihBas = null;
    Rapor.PKomFatTarihBit = null;
    Rapor.PGelenFatTarihBas = null;
    Rapor.PGelenFatTarihBit = null;

    if (tarihTip == 0) {
      Rapor.PKayitTarihBas = KayitTarihiBasla;
      Rapor.PKayitTarihBit = KayitTarihiBitis;
    } else if (tarihTip == 1) {
      Rapor.PDonem1Bas = KayitTarihiBasla;
      Rapor.PDonem1Bit = KayitTarihiBitis;
    } else if (tarihTip == 2) {
      Rapor.PDonem2Bas = KayitTarihiBasla;
      Rapor.PDonem2Bit = KayitTarihiBitis;
    } else if (tarihTip == 3) {
      Rapor.PFatTarihBas = KayitTarihiBasla;
      Rapor.PFatTarihBit = KayitTarihiBitis;
    } else if (tarihTip == 4) {
      Rapor.PKomFatTarihBas = KayitTarihiBasla;
      Rapor.PKomFatTarihBit = KayitTarihiBitis;
    } else if (tarihTip == 5) {
      Rapor.PGelenFatTarihBas = KayitTarihiBasla;
      Rapor.PGelenFatTarihBit = KayitTarihiBitis;
    }

    return Rapor;
  },

  ParametreOlustur(Rapor) {
    let RaporParam = {};

    RaporParam.PSirketNo = Rapor.PSirketNo;
    RaporParam.PCariSirket = Rapor.PCariSirket;
    RaporParam.PPNR_No = Rapor.PPNR_No;
    RaporParam.PPNR_ParaBirimi = Rapor.PPNR_ParaBirimi;
    RaporParam.PKayitTarihBas = Rapor.PKayitTarihBas;
    RaporParam.PKayitTarihBit = Rapor.PKayitTarihBit;
    RaporParam.PDonem1Bas = Rapor.PDonem1Bas;
    RaporParam.PDonem1Bit = Rapor.PDonem1Bit;
    RaporParam.PDonem2Bas = Rapor.PDonem2Bas;
    RaporParam.PDonem2Bit = Rapor.PDonem2Bit;
    RaporParam.PFatTarihBas = Rapor.PFatTarihBas;
    RaporParam.PFatTarihBit = Rapor.PFatTarihBit;
    RaporParam.PKomFatTarihBas = Rapor.PKomFatTarihBas;
    RaporParam.PKomFatTarihBit = Rapor.PKomFatTarihBit;
    if (Rapor.PPNRBir != null) {
      RaporParam.PPNRBir = Rapor.PPNRBir.kod;
    } else {
      RaporParam.PPNRBir = null;
    }

    //if (Rapor.PCariKod != null) {
    //  RaporParam.PCariKod = Rapor.PCariKod.id;
    //} else {
    RaporParam.PCariKod = Rapor.PCariKod;
    //}
    RaporParam.PSaticiTip = Rapor.PSaticiTip;

    if (Rapor.PSaticiKod != null) {
      RaporParam.PSaticiKod = Rapor.PSaticiKod.kod;
    } else {
      RaporParam.PSaticiKod = null;
    }

    RaporParam.PDosyaTip = Rapor.PDosyaTip;
    RaporParam.PDosya = Rapor.PDosya;

    if (Rapor.PAcente != null) {
      RaporParam.PAcente = Rapor.PAcente.kod;
    } else {
      RaporParam.PAcente = null;
    }

    RaporParam.PCariHesapGrubu = Rapor.PCariHesapGrubu;
    RaporParam.PCariTip = Rapor.PCariTip;
    RaporParam.PSaticiGrup = Rapor.PSaticiGrup;
    RaporParam.PSaticiIc_Dis = Rapor.PSaticiIc_Dis;
    if (Rapor.PTurOp != null) {
      RaporParam.PTurOp = Rapor.PTurOp.kod;
    } else {
      RaporParam.PTurOp = null;
    }

    RaporParam.PFaturali = Rapor.PFaturali;
    RaporParam.POpsiyon = Rapor.POpsiyon;
    RaporParam.PAnaTip = Rapor.PAnaTip;

    //if (Rapor.PCariAnaHesap != null) {
    //  RaporParam.PCariAnaHesap = Rapor.PCariAnaHesap.id;
    //} else {
    RaporParam.PCariAnaHesap = Rapor.PCariAnaHesap;
    //}

    RaporParam.PIptalRaporu = Rapor.PIptalRaporu;
    RaporParam.PRezGrupID = Rapor.PRezGrupID;
    RaporParam.PSatisGrubu = Rapor.PSatisGrubu;
    RaporParam.PSatisGrupTip = Rapor.PSatisGrupTip;
    RaporParam.PSaticiOdemesiHesapla = Rapor.PSaticiOdemesiHesapla;

    if (Rapor.PMasrafMerkezi != null) {
      RaporParam.PMasrafMerkezi = Rapor.PMasrafMerkezi.kod;
    } else {
      RaporParam.PMasrafMerkezi = null;
    }

    RaporParam.PAcenteDepartmanID = Rapor.PAcenteDepartmanID;
    RaporParam.PPozisyonNo = Rapor.PPozisyonNo;
    RaporParam.PSatisFaturaNo = Rapor.PSatisFaturaNo;
    RaporParam.PMusteriOdemelilerHaric = Rapor.PMusteriOdemelilerHaric;
    RaporParam.PReferans = Rapor.PReferans;
    RaporParam.PSatisTip1 = Rapor.PSatisTip1;
    RaporParam.PSatisTip2 = Rapor.PSatisTip2;
    RaporParam.PSatisTip3 = Rapor.PSatisTip3;
    RaporParam.PSatisTip4 = Rapor.PSatisTip4;
    RaporParam.PGelenFatTarihBas = Rapor.PGelenFatTarihBas;
    RaporParam.PGelenFatTarihBit = Rapor.PGelenFatTarihBit;
    RaporParam.PProfilSablonId = Rapor.PProfilSablonId;
    RaporParam.PKomisyonFaturali = Rapor.PKomisyonFaturali;
    RaporParam.PGelenFaturali = Rapor.PGelenFaturali;
    RaporParam.PProfilSablonId=Rapor.PProfilSablonId;
    return RaporParam;
  },
  //burada dil dosyasi uygulayinca sayfa patliyor.
  IslemTarihTip() {
    return [
      {
        text: i18n.tc('Record-Date-Ascending'),
        value: 0,
      },
      {
        text: i18n.tc('Entry-date'),
        value: 1,
      },
      {
        text: i18n.tc('Release-date'),
        value: 2,
      },
      {
        text: i18n.tc('Sales-Invoice-Date'),
        value: 3,
      },
      {
        text: i18n.tc('Commission-Invoice-Date'),
        value: 4,
      },
      {
        text: i18n.tc('Received-Invoice-Date'),
        value: 5,
      },
    ];
  },

  components: {
    customdialog,
    tarihcomp: tarihcomp,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    cariaracomp,

    rez,
  },
computed: {
},

  methods: {
    simpleModeYukle() {
  var manageload = null;

  try {
    manageload = JSON.parse(window.localStorage.getItem("WebUserManageLoad"));
  } catch (e) {
    manageload = null;
  }

  if (manageload && manageload.UserInfo) {
    this.simpleMode =
      manageload.UserInfo.SimpleMode === true ||
      manageload.UserInfo.SimpleMode === 1 ||
      manageload.UserInfo.SimpleMode === "1" ||
      manageload.UserInfo.SimpleMode === "true";
  }
},

simpleModeDefaultlariUygula() {
  if (!this.simpleMode) {
    return;
  }

  this.Rapor.PMasrafMerkezi = null;
  this.Rapor.PProfilSablonId = null;
  this.Rapor.PReferans = null;
  this.Rapor.PAnaTip = null;
  this.Rapor.PCariHesapGrubu = null;
  this.Rapor.PSaticiGrup = null;
},
    open(title) {
      this.simpleModeYukle();
  this.simpleModeDefaultlariUygula();
      this.returnData.Status = false;
      this.dialog = true;

      this.dovisList();
      this.getSablonTipList();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
     getSablonTipList() {
  

      tool.http_post(this, "SablonTipList", null).then(
    response => {
      this.sablonTipList = response.body;
     
     
    },
    response => {
     
    }
  );

 

},
    yes() {
      this.simpleModeYukle();
  this.simpleModeDefaultlariUygula();
      this.returnData.Status = true;
      this.returnData.Rapor = this.Rapor;
      this.resolve(this.returnData);
      this.dialog = false;
    },
    cancel() {
      this.Rapor = this.EmptyPrametre2();
      this.returnData.Rapor = this.EmptyPrametre2();
      this.returnData.Status = false;
      this.tumsirketler = false;
      this.resolve(this.returnData);
      this.dialog = false;
    },
    EmptyPrametre2,

    dovisList() {
      if (this.doviztipi.length <= 0) {
        var credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );
        var params = {
          CompanyCode: credentials.SirketKodu,
        };

        this.$http
          .post(auth.API_URL + "api/currency/List", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
              this.doviztipi = response.body;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              }
            }
          );
      }
    },
    TumSirketlerParametre() {
      var result = this.tumsirketler;
      return result;
    },
  },
};

function EmptyPrametre2() {
  return {
    PSirketNo: null, //eklendi
    PCariSirket: null, //eklendi
    PPNR_No: null, //eklendi
    PPNR_ParaBirimi: "TL", //eklendi
    PKayitTarihBas: null, //eklendi
    PKayitTarihBit: null, //eklendi
    PDonem1Bas: null, //eklendi
    PDonem1Bit: null, //eklendi
    PDonem2Bas: null, //eklendi
    PDonem2Bit: null, //eklendi
    PFatTarihBas: null, //eklendi
    PFatTarihBit: null, //eklendi
    PKomFatTarihBas: null, //eklendi
    PKomFatTarihBit: null, //eklendi
    PCariKod: null, //eklendi
    PSaticiTip: null, //eklendi
    PSaticiKod: null, //eklendi
    PDosyaTip: null,
    PDosya: null,
    PAcente: null,
    PPNRBir: null,
    PCariHesapGrubu: null, //eklendi
    PCariTip: null,
    PSaticiGrup: null, //eklendi
    PSaticiIc_Dis: null, //eklendi
    PTurOp: null, //eklendi
    PFaturali: null,
    POpsiyon: null, //eklendi
    PAnaTip: null, //eklendi
    PCariAnaHesap: null, //eklendi
    PIptalRaporu: null,
    PRezGrupID: null,
    PSatisGrubu: null,
    PSatisGrupTip: null,
    PSaticiOdemesiHesapla: null,
    PMasrafMerkezi: null, //eklendi
    PAcenteDepartmanID: null,
    PPozisyonNo: null,
    PProfilSablonId:null,
    PSatisFaturaNo: null,
    PMusteriOdemelilerHaric: null,
    PReferans: null, //eklendi
    PSatisTip1: false,
    PSatisTip2: false,
    PSatisTip3: false,
    PSatisTip4: false,
    PGelenFatTarihBas: null, //eklen
    PGelenFatTarihBit: null, //eklendi
    PProfilSablonId: null,
    PKomisyonFaturali: null,
    PGelenFaturali: null,
  };
}
</script>
